import PlayerControls from './PlayerControls'

export default PlayerControls
